// --- SaniQ ---
import * as OtpConstants from '../constants';

const initialState = {
  isSending: false
};

export function otp(state = initialState, action) {
  switch (action.type) {
    case OtpConstants.SEND_OTP_CODE_STARTED:
      return Object.assign({}, state, {isSending: true});
    case OtpConstants.SEND_OTP_CODE_COMPLETED:
      return Object.assign({}, state, {isSending: false});
    default:
      return state;
  }
}
